<template>
  <div class="topTitle">
    <el-row>
      <el-col :span="12"
        ><div class="title"><h1>遵义医科大学附属医院</h1></div></el-col
      >
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.topTitle {
  @include autoInner;
  width: 1400px;
  padding: 40px 0px;
  color: #222222;
  h1 {
    font-size: 36px;
  }
}
</style>
